// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { AnalyticsStore } from 'bernie-core';

// shared-ui
import { LocalizedComponentProps, LocalizedText, withLocalization } from '@shared-ui/localization-context';

// ui
import { UitkPrimaryButton } from 'uitk-react-button';

// util
import { modifyLocaleParam } from '../../util/LocaleParamTransformer';
import { getUserAnalyticsMicroMessage } from '../../util/analytics';

import { UserAuthStore } from 'stores';

export interface AffiliateCTAProps extends LocalizedComponentProps {
  locale?: string;
  analytics?: AnalyticsStore;
  userAuth?: UserAuthStore;
}

@withLocalization
@inject('analytics', 'userAuth')
export class AffiliateCTA extends React.Component<AffiliateCTAProps> {
  public render() {
    const link = `/${modifyLocaleParam(this.props.locale)}/signup`;

    const referrerId = 'affhub_header_signup.selected';
    const linkName = 'AffHub Header SignUp Selected';

    const { analytics, userAuth } = this.props;

    const analyticsSignupSelected = {
      id: referrerId,
      callback: () => {
        if (analytics && typeof analytics.trackEvent === 'function') {
          analytics.trackEvent(referrerId, linkName, null, null, true, [
            getUserAnalyticsMicroMessage(userAuth?.currentUserDetails),
          ]);
        }
      },
    };

    return (
      <>
        <UitkPrimaryButton analytics={analyticsSignupSelected} tag={'a'} href={link} data-cy="sign-up-link">
          <LocalizedText message="common.join_now" />
        </UitkPrimaryButton>
      </>
    );
  }
}
